import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { BILLING } from "@/constants/testIds";
import { CheckCircle2 } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let mounted = true;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (!mounted) return;
        setStatus(data);
        setTries((t) => t + 1);
        attempts++;
        if (data.payment_status !== "paid" && attempts < 15) {
          setTimeout(poll, 2000);
        }
      } catch {
        if (attempts < 5 && mounted) setTimeout(poll, 2000);
      }
    };
    poll();
    return () => {
      mounted = false;
    };
  }, [sid]);

  return (
    <div
      data-testid={BILLING.successContainer}
      className="p-10 max-w-2xl mx-auto"
    >
      <CheckCircle2 className="w-16 h-16 mb-6" style={{ color: "#00C781" }} strokeWidth={1.5} />
      <div className="overline mb-3">Order confirmation</div>
      <h1 className="font-display text-5xl font-black tracking-tighter mb-4">
        {status.payment_status === "paid"
          ? "Subscription active."
          : "Finalizing your subscription…"}
      </h1>
      <p className="text-neutral-500 mb-8">
        {status.payment_status === "paid"
          ? `Your ${status.lookup_key?.replace("_monthly", "")} plan is live. AI lead-gen agents will start on your next login.`
          : `We're confirming the payment (attempt ${tries}). This page will update automatically.`}
      </p>
      <div className="flex gap-3">
        <Link to="/" className="lf-btn-primary inline-block">
          Back to dashboard →
        </Link>
        <Link to="/billing" className="lf-btn-outline inline-block">
          Billing
        </Link>
      </div>
      {sid && (
        <div className="mt-8 text-xs font-mono text-neutral-400">
          Session: {sid}
        </div>
      )}
    </div>
  );
}
